<div class="sortable-header" [class.sortable]="isSortable()" (click)="onSort()">
	<span [class.has-tooltip]="tooltip()" [md-tooltip]="tooltip()" md-tooltip-position="bottom">{{ label() }}</span>
	@if (showAsc()) {
		<md-icon icon="untitled-ui/arrows/chevron-up"></md-icon>
	} @else if (showDesc()) {
		<md-icon icon="untitled-ui/arrows/chevron-down"></md-icon>
	} @else if (showNeutral()) {
		<md-icon class="faded" icon="untitled-ui/arrows/chevron-selector-vertical"></md-icon>
	}
</div>
